// Safe in-app back navigation.
//
// Previous version relied on `window.history.state.idx > 0`, but React Router
// doesn't populate `idx` on every push — direct URL entries, redirects, and
// some remounts leave `idx === 0` even when a legitimate in-app entry sits
// underneath. That made `Back` almost always fall through to `fallback`
// (typically /dashboard), skipping the actual previous page.
//
// The new logic: if the browser reports more than one history entry AND we
// can go back, call `navigate(-1)`. As a safety net we listen for the URL
// staying the same after ~150ms (which only happens if `-1` bounced us out
// of the SPA) and then jump to the fallback route.
export function safeBack(navigate, fallback = "/dashboard") {
    if (typeof window === "undefined") {
        navigate(fallback, { replace: true });
        return;
    }
    const before = window.location.pathname + window.location.search;
    const canGoBack = window.history.length > 1;
    if (canGoBack) {
        navigate(-1);
        // If navigate(-1) didn't change the URL within ~150ms (e.g. because
        // the user landed here from an external link and there is no in-app
        // entry), fall back to a sensible route instead of dead-ending.
        setTimeout(() => {
            const after = window.location.pathname + window.location.search;
            if (after === before) {
                navigate(fallback, { replace: true });
            }
        }, 150);
    } else {
        navigate(fallback, { replace: true });
    }
}
